// 友情链接管理
import http from "@/jslibs/axios/http";

// 友情链接列表
export const list = (data) => http.get("/v1/cms/FriendLink", data);

// 友情链接新增
export const add = (data) => http.post("/v1/cms/FriendLink", data);

// 友情链接编辑
export const edit = ({ uuid, ...data }) => http.put(`/v1/cms/FriendLink/${uuid}`, data);

// 友情链接删除
export const del = ({ cuuid }) => http.delete(`/v1/cms/FriendLink/${cuuid}`);

// 友情链接详情
export const detail = ({ cuuid, ...data }) => http.get(`/v1/cms/FriendLink/${cuuid}`, data);
